import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { PremiumDiff } from '@models/swagger';
import { DifferenceParams } from './service';

export enum DifferenceActions {
  Failure = '[Policy Difference] Failure',
  Request = '[Policy Difference] Request',
  Success = '[Policy Difference] Success',
  Reset = '[Policy Difference] Reset',
}

export const DifferenceFailure = createAction(DifferenceActions.Failure, props<{ error: HttpErrorResponse }>());

export const DifferenceRequest = createAction(DifferenceActions.Request, props<{ parameters: DifferenceParams }>());

export const DifferenceSuccess = createAction(DifferenceActions.Success, props<{ data: PremiumDiff[] }>());

export const DifferenceReset = createAction(DifferenceActions.Reset);
